<template>
  <div class="scroll-list-wrap">
    <div class="tabs">
      <div 
        class="tab" 
        :class="{ active: activeTab === 'personal' }" 
        @click="switchTab('personal')"
      >
        待视频
      </div>
      <div 
        class="tab" 
        :class="{ active: activeTab === 'finshed' }" 
        @click="switchTab('finshed')"
      >
        已完成
      </div>
      <div 
        class="tab" 
        :class="{ active: activeTab === 'family' }" 
        @click="switchTab('family')"
      >
        亲属订单
      </div>
    </div>
    <cube-scroll
        ref="scroll"
        :data="items"
        :options="options"
        @pulling-up="onPullingUp">
        <ul class="nav-wrapper">
          <div class='tip' v-if=' items.length===0 '>暂无预约</div>

          <li v-for="(item, index) in items" :key="index" class="nav-item">
            <div class='item-wrapper'>
              <div class='main-info'>
                <div class='icon'>
                  <img style="width: 100%;height: 100%; border-radius: 8px;" v-lazy="item.headPortrait">
                </div>
                <div v-if="!orderTimeStyle" class='other'>
                  <div class='other-info'>{{item.realname}}</div>
                  <div class='other-info'>{{item.hospitalName}}</div>
                  <div class='other-info'>{{item.departmentName}}</div>
                </div>
                <div v-else class='other'>
                  <div class='other-info'>{{item.realName}}</div>
                  <div class='other-info'>{{item.hospitalName}}</div>
                  <div class='other-info'>{{item.departmentsName}}</div>
                </div>
              </div>
              <div v-if="!orderTimeStyle" class='item-sub-info'>{{item.time}} {{_getWeekDay(item.week)}} {{item.startTime}}-{{item.endTime}}</div>
              <div v-else class='item-sub-info'>{{ _getOrderTimeStyle(item.startTime, item.endTime) }}</div>
              
              <!--  <div class='button' @click="gotoRoom(item)">开始视频</div> -->
              <div class="button-container">
                <div class='button bind-button' v-if="activeTab === 'personal'" @click="gotoBindOrder(item)">亲属分享</div>
                <div v-if="!orderTimeStyle" class='button video-button' @click="gotoRoom(item)">开始视频</div>
              </div>
            </div>
          </li>
        </ul>

    </cube-scroll>
  </div>
</template>

<script>
import { getOrderByPhone, getOrderHistory } from '@/api/yuyueApi'
import { bindOrderList } from '@/api/orderBindApi'
import { getUserId, getPhone } from '@/common/js/cache'
export default {
  name: '',
  data () {
    return {
      activeTab: 'personal', 
      page: 1,
      items:[],
      pullUpLoadObj: true,
      orderTimeStyle: false,
    }
  },
  created () {
    if (this.activeTab === 'personal') {
      this.getListData()
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    switchTab(tab) {
      this.items = [];
      this.activeTab = tab
      this.page = 1
      if (tab === 'personal') {
        this.orderTimeStyle = false
        this.getListData()
      } else if (tab === 'family') {
        this.orderTimeStyle = false
        this.bindOrderList()
      }else if (tab === 'finshed') {
        this.orderTimeStyle = true
        this.getOrderFinished()
      }
     
    },
    async getListData () {
      this.page = 1
      const params = {
        page: 1,
        size: '20'
      }
      try {
        const res = await getOrderByPhone(params)
        if (!res.obj){
          return
        }
        this.items = res.obj
      } catch (error) {
        this.$refs.scroll.forceUpdate()
      }
    },
    async getOrderFinished(){
      const params = {
        phone: getPhone()
      }
      try {
        const res = await getOrderHistory(params)
        if (!res.obj){
          return
        }
        this.items = res.obj
      } catch (error) {
        this.$refs.scroll.forceUpdate()
      }
    },
    async bindOrderList(){
      const params = {
        userId:getUserId(),
      }
      const res = await bindOrderList(params)
      if (res.code === '9000200') {
        this.items = res.result
      }
    },

    async loadMore () {
      const p = this.page + 1
      const params = {
        page: p,
        size: '20'
      }
      try {
        const res = await getOrderByPhone(params)
        if (res.obj && res.obj.length > 0) {
          this.page = this.page + 1
          this.items = this.doclist.concat(res.obj)
        } else {
          this.pullUpLoadObj = false
          this.$refs.scroll.forceUpdate()
          this.$refs.scroll.refresh()
          this.toast = this.$createToast({
            time: 1000,
            txt: '暂无更多',
            type: 'txt'
          }).show()
        }
      } catch (err) {
        this.$refs.scroll.forceUpdate()
      }
    },
    onPullingUp() {
      this.loadMore()
    },

    _getWeekDay (num) {
      const weeks = {
        1: '周日',
        2: '周一',
        3: '周二',
        4: '周三',
        5: '周四',
        6: '周五',
        7: '周六'
      }
      return weeks[parseInt(num)]
    },
    _getOrderTimeStyle(start, end) {
      return  start.substring(0,start.lastIndexOf(':')) + ' - ' + end.substring(end.indexOf(" "), end.lastIndexOf(':'));
     
    },
    gotoRoom(item){
     // window.location.href =  `https://wx.warmdoctor.com/vcsVideo/video.html?orderId=${item.id}`
      let orderType = null;
      if(this.activeTab === 'personal'){
        orderType = 1;
      }else{
        orderType = 2;
      }
      window.location.href =  `https://userwxw-f.first-doctor.com/thirdPage2?orderId=${item.id}&orderType=${orderType}&userId=${getUserId()}`

    },
    gotoBindOrder(item){
      this.$router.push({
          path: '/bindKin',
          query: {
            orderId: item.id
          }
      })
    },
  },
  computed: {
    options() {
      return {
        pullDownRefresh: false,
        pullUpLoad: this.pullUpLoadObj,
        scrollbar: false
      }
    }
  },
  watch: {},
  components: {}
}
</script>

<style lang='stylus' scoped>
.scroll-list-wrap {
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .tabs {
    display: flex;
    height: 44px;
    background-color: #333;
    
    .tab {
      flex: 1;
      text-align: center;
      line-height: 44px;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      
      &.active {
        color: yellow;
        border-bottom: 2px solid yellow;
      }
    }
  }
  .tip{
    text-align center
    color white
    padding 30px
    font-size 16px
  }
  .item-wrapper{
    padding 20px 10px
    border 1px solid rgba(255,255,255,0.1)
    color white
    position relative
    .main-info {
      display flex
      .icon{
        flex 0 0 80px
        height 80px
      }
      .other {
        padding-left 10px
        font-size 14px
        .other-info{
          margin-bottom 5px
        }
      }
    }
    .item-sub-info {
      padding-top 10px
      font-size 14px
    }
    .button-container {
      position absolute
      right 10px
      top 50%
      transform translateY(-50%)
      display flex
      flex-direction column
      gap 8px
      .button{
        text-align center
        font-size 14px
        width 90px
        line-height 30px
        border-radius 35px
        color #4a4a4a
      }
      .bind-button {
        background-color yellow
      }
      .video-button {
        background-color yellow
      }
    }
  }
}
</style>
